import React, { useEffect, useState } from "react";
import settingScheduleService from "../../../services/settingSchedule.service";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Modal } from "antd";
import Swal from "sweetalert2";

const CheckList = (props: any) => {
  const { schedule, curri } = props;
  const [form] = Form.useForm();
  const [showBtn, setShowBtn] = useState(false);
  useEffect(() => {
    (async () => {
      settingScheduleService.countCourse(schedule).then((res) => {
        if (res.data.length > 0) {
          const count = res.data.filter(
            (x: any) => x.course.owner.id === curri.id
          ).length;
          if (count > 0) {
            setShowBtn(true);
          }
        }
      });
    })();
  }, []);

  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const [courseList, setCourseList] = useState([]);
  // const [sendList, setSendList] = useState([]);

  useEffect(() => {
    (async () => {
      await settingScheduleService.getCourse(curri.id).then(async (course) => {
        setCourseList(course.data);
      });
    })();
  }, []);

  const onFinish = (values: {
    course: string;
    responsible: string;
    group:string;
    list: [{ course: string; responsible: string,group:string }];
  }) => {
    const { course, responsible, list,group } = values;
    const courseArray =
      values.list === undefined
        ? [{ course, responsible,group }]
        : [{ course, responsible,group }, ...list];


        // console.log(courseArray);
        
    settingScheduleService
      .saveSetting({
        schedule,
        sendItem: courseArray,
      })
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleCancel();
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "มีบางอย่างผิดพลาด ตรวจสอบข้อมูลอีกครั้ง!",
        });
      });
  };

  const onChange = (value: string) => {
    console.log(`Change ${value}`);
  };

  if (showBtn) return <></>;
  return (
    <>
      <button onClick={showModal} className="btn btn-sm btn-outline-success">
        <i className="bi bi-pencil-square"></i> ตั้งค่ารายวิชา
      </button>

      <Modal
        visible={visible}
        title="ตั้งค่ารายวิชาที่ต้องส่งเอกสาร"
        width={1000}
        onCancel={handleCancel}
        footer={[
          <button
            type="submit"
            className="btn btn-primary"
            onClick={form.submit}
          >
            เพิ่มข้อมูล
          </button>,
          <button
            type="reset"
            className="btn btn-warning ms-1"
            onClick={() => form.resetFields()}
          >
            ล้าง
          </button>,

          <button
            type="button"
            className="btn btn-danger ms-1"
            onClick={handleCancel}
          >
            Close
          </button>,
        ]}
      >
        <Form
          name="dynamic_form_nest_item"
          onFinish={onFinish}
          autoComplete="off"
          form={form}
        >
          <div className="row">
            <div className="col-5">
              <Form.Item
                name={"course"}
                rules={[
                  {
                    required: true,
                    message: "กรุณาเลือกรายวิชากด้วยครับ",
                  },
                ]}
              >
                <Select
                  placeholder="เลือกรายวิชา"
                  showSearch
                  optionFilterProp="children"
                  onChange={onChange}
                >
                  {courseList.map((d: any) => {
                    return (
                      <Select.Option key={d.id} value={d.id}>
                        ({d.courseCode}) {d.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </div>
            <div className="col-4">
              <Form.Item
                name="responsible"
                rules={[
                  {
                    required: true,
                    message: "ระบุอาจารย์ผู้รับผิดชอบ",
                  },
                ]}
              >
                <Input placeholder="อาจารย์ผู้รับผิดชอบ" />
              </Form.Item>
            </div>
            <div className="col"> <Form.Item
              name="group"
              rules={[
                {
                  required: true,
                  message: "ระบุกลุ่มเรียน",
                },
              ]}
            >
              <Input placeholder="กลุ่มเรียน" />
            </Form.Item></div>
          </div>
          <Form.List name="list">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div className="row">
                    <div className="col-5">
                      <Form.Item
                        {...restField}
                        name={[name, "course"]}
                        rules={[
                          {
                            required: true,
                            message: "กรุณาเลือกรายวิชากด้วยครับ",
                          },
                        ]}
                      >
                        <Select
                          placeholder="เลือกรายวิชา"
                          showSearch
                          optionFilterProp="children"
                          // onSelect={onSelect}
                          onChange={onChange}
                        >
                          {courseList.map((d: any) => {
                            return (
                              <Select.Option key={d.id} value={d.id}>
                                ({d.courseCode}) {d.name}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div>
                    <div className="col-4">
                      <Form.Item
                        {...restField}
                        name={[name, "responsible"]}
                        rules={[
                          {
                            required: true,
                            message: "ระบุอาจารย์ผู้รับผิดชอบ",
                          },
                        ]}
                      >
                        <Input placeholder="อาจารย์ผู้รับผิดชอบ" />
                        {/* <Select
                          mode="tags"
                          open={false}
                          tokenSeparators={[","]}
                        ></Select> */}
                      </Form.Item>
                    </div>
                    <div className="col-2">
                      <Form.Item
                        {...restField}
                        name={[name, "group"]}
                        rules={[
                          {
                            required: true,
                            message: "ระบุกลุ่มเรียน",
                          },
                        ]}
                      >
                        <Input placeholder="กลุ่มเรียน" />
                        {/* <Select
                          mode="tags"
                          open={false}
                          tokenSeparators={[","]}
                        ></Select> */}
                      </Form.Item>
                    </div>
                    
                    <div className="col">
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </div>
                  </div>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusCircleOutlined />}
                  >
                    เพิ่มรายวิชาที่ต้องการส่ง
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </>
  );
};

export default CheckList;
